<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/q3AcGw/tc-custom/9780935926408.jpg?1686833493526" alt="This image is the cover for the book Wong on Dice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wong on Dice
      </h1>
      <p class="bookDescription body article font2">
        <p>Wong on Dice explains how to do something extremely difficult: beat the casino game of craps through skillful shooting.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stanford Wong
      </h2>
      
      <p class="authorDescription body article">Stanford Wong loves to solve puzzles, and has figured out how to beat many casino games.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pi Yee Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06606676